import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View, ScrollView } from 'react-native';
import { DataStore } from 'aws-amplify';
import { Farm, Cooperation, UserGroup, AppUser, UserType } from '../../models';
import * as AppConst from '../../components/AppConst';
import * as DataStoreUtil from '../../components/DataStoreUtil';
import * as CmnUtil from '../../components/CmnUtil';
import IconImages from '../../components/IconImages';

/** ================================
*  組織詳細画面
*  ================================*/
const GroupDetail = ({ closeFunction, groupId }: { closeFunction: Function, groupId: string }) => {

  const [groupInfo, setGroupInfo] = useState<UserGroup | undefined>(undefined);
  const [farmList, setFarmList] = useState<Farm[]>([]);
  const [cooperationList, setCooperationList] = useState<UserGroup[]>([]);
  const [userList, setUserList] = useState<AppUser[]>([]);

  useEffect(() => {
    (async () => {
      // 組織情報取得
      const userGroup = (await DataStore.query(UserGroup, groupId));
      if (userGroup == undefined) {
        setGroupInfo(undefined);
        setFarmList([]);
        setCooperationList([]);
        return;
      }
      setGroupInfo(userGroup);

      // 圃場情報取得
      const farms = (await DataStore.query(Farm)).filter(c => c.group.id === groupId);
      setFarmList([...farms]);

      // 協力組織情報取得
      const tmpCooperationList = [];
      const cooperationTo = (await DataStore.query(Cooperation, c => c.groupID('eq', groupId)));
      for (const cooperation of cooperationTo) {
        const group = (await DataStore.query(UserGroup, c => c.id('eq', cooperation.cooperationGroupID).or(c => c.groupType('eq', UserType.INSTRUCTOR).groupType('eq', UserType.PRODUCER))));
        if (group.length > 0) tmpCooperationList.push(group[0]);
      }
      setCooperationList([...tmpCooperationList]);

      // ユーザー情報取得
      const users = (await DataStore.query(AppUser)).filter(c => c.group.id === groupId);
      setUserList([...users]);

    })();
  }, []);

  return (
    <View style={AppConst.styles.dialog}>
      <View style={AppConst.styles.dialogContents}>
        <View style={{ backgroundColor: AppConst.defaultBaseColor, width: 450, borderRadius: 10 }}>
          <AppConst.DialogHeader closeFunction={closeFunction} />

          <ScrollView style={{ maxHeight: 450, paddingLeft: 10, paddingRight: 10, paddingBottom: 10 }}>

            <Text style={styles.title}>組織</Text>
            {groupInfo && <View style={{ backgroundColor: AppConst.defaultBaseInputColor, borderRadius: 10 }}>
              <View style={{ flexDirection: 'row' }}>
                <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                  <CmnUtil.S3Image imageKey={groupInfo.icon} style={styles.icon} defaultSource={IconImages.ic_group} />
                </View>
                <View style={{ paddingLeft: 10, width: '100%' }}>
                  <View >
                    <Text>[{DataStoreUtil.convUserType(groupInfo.groupType)}]</Text>
                  </View>
                  <Text>{groupInfo.groupName}</Text>
                </View>
              </View>
              <View style={{ alignItems: 'flex-end' }}>
                <Text style={{ color: '#aaaaaa' }}>{groupInfo.id}</Text>
              </View>
            </View>}

            {groupInfo?.groupType == UserType.PRODUCER && <View>
              <Text style={styles.title}>圃場</Text>
              {farmList.map((data: Farm, index: number) => (
                <View key={index} style={{ backgroundColor: AppConst.defaultBaseInputColor, borderRadius: 10, marginTop: 5, marginBottom: 5 }}>
                  <View style={{ paddingLeft: 10, width: '100%' }}>
                    <Text>{data.name}</Text>
                    <Text>{data.memo}</Text>
                  </View>
                  <View style={{ alignItems: 'flex-end' }}>
                    <Text style={{ color: '#aaaaaa' }}>{data.id}</Text>
                  </View>
                </View>
              ))}
              {farmList.length == 0 && <View>
                <Text>圃場はありません</Text>
              </View>}
            </View>}

            <Text style={styles.title}>協力組織</Text>
            {cooperationList.map((data: UserGroup, index: number) => (
              <View key={index} style={{ backgroundColor: AppConst.defaultBaseInputColor, borderRadius: 10, marginTop: 5, marginBottom: 5 }}>
                <View style={{ flexDirection: 'row' }}>
                  <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <CmnUtil.S3Image imageKey={data.icon} style={styles.icon} defaultSource={IconImages.ic_group} />
                  </View>
                  <View style={{ paddingLeft: 10, width: '100%' }}>
                    <View>
                      <Text>[{DataStoreUtil.convUserType(data.groupType)}]</Text>
                    </View>
                    <Text>{data.groupName}</Text>
                  </View>
                </View>
                <View style={{ alignItems: 'flex-end' }}>
                  <Text style={{ color: '#aaaaaa' }}>{data.id}</Text>
                </View>
              </View>
            ))}
            {cooperationList.length == 0 && <View>
              <Text>協力組織はありません</Text>
            </View>}

            <Text style={styles.title}>ユーザー</Text>
            {userList.map((data: AppUser, index: number) => (
              <View key={index} style={{ backgroundColor: AppConst.defaultBaseInputColor, borderRadius: 10, marginTop: 5, marginBottom: 5 }}>
                <View style={{ flexDirection: 'row' }}>
                  <View style={{ alignItems: 'center', justifyContent: 'center' }}>
                    <CmnUtil.S3Image imageKey={data.icon} style={styles.icon} defaultSource={IconImages.ic_user} />
                  </View>
                  <View style={{ paddingLeft: 10, width: '100%' }}>
                    <View >
                      <Text>[{DataStoreUtil.convUserType(data.type)}]</Text>
                    </View>
                    <Text>{data.username}</Text>
                    <Text>{data.authUserID}</Text>
                    <Text>{data.profile}</Text>
                  </View>
                </View>
                <View style={{ alignItems: 'flex-end' }}>
                  <Text style={{ color: '#aaaaaa' }}>{data.id}</Text>
                </View>
              </View>
            ))}
            {userList.length == 0 && <View>
              <Text>ユーザーはいません</Text>
            </View>}

          </ScrollView>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  title: {
    marginTop: 10,
  },
  icon: {
    width: 50,
    height: 50,
    borderRadius: 25,
  },
});

export default GroupDetail;
